import React, { useContext } from "react"
import { observer } from "mobx-react"
import { Anchor, Group, Text } from "@mantine/core"
import { AppWorkspaceContext } from "../stores/AppWorkspace"
import {
  AGENTS_PATH,
  AGENTS_SLUG,
  GITHUB_URL,
  integrationPath,
  LEARN_PATH,
  NWC_PATH,
  PLATFORMS_PATH,
  SWAP_PROVIDER_PATH
} from "../helpers/constants"
import { FRAMEWORKS, LIVE_PLATFORMS } from "../../docs/catalog"

export const SiteFooter: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext)

  return (
    <footer className="or-footer">
      {/* The framework pages first: the entry points a visitor from outside is
          most likely to want next. */}
      <Group gap="md" className="or-footer-frameworks" wrap="wrap">
        <Text size="sm" c="dimmed" fw={700}>
          Frameworks
        </Text>
        {FRAMEWORKS.map((framework) => (
          <Anchor
            key={framework.id}
            size="sm"
            c="dimmed"
            href={integrationPath(framework.id)}
            onClick={(e) => { e.preventDefault(); workspace.goIntegration(framework.id) }}
          >
            {framework.label}
          </Anchor>
        ))}
      </Group>
      {LIVE_PLATFORMS.length ? (
        <Group gap="md" className="or-footer-frameworks" wrap="wrap">
          <Text size="sm" c="dimmed" fw={700}>
            Platforms
          </Text>
          {LIVE_PLATFORMS.map((platform) => (
            <Anchor
              key={platform.id}
              size="sm"
              c="dimmed"
              href={platform.path as string}
              onClick={(e) => { e.preventDefault(); workspace.goPlatforms(platform.id) }}
            >
              {platform.label}
            </Anchor>
          ))}
          <Anchor size="sm" c="dimmed" href={PLATFORMS_PATH} onClick={(e) => { e.preventDefault(); workspace.goPlatforms() }}>
            All platforms
          </Anchor>
        </Group>
      ) : null}
      <Group justify="space-between" wrap="wrap" gap="sm">
        <Text size="sm" c="dimmed">
          openreceive.org
        </Text>
        <Group gap="md">
          <Anchor size="sm" c="dimmed" href="/api_docs" onClick={(e) => { e.preventDefault(); workspace.goApiDocs() }}>
            API docs
          </Anchor>
          <Anchor size="sm" c="dimmed" href="/guides" onClick={(e) => { e.preventDefault(); workspace.goGuides() }}>
            Guides
          </Anchor>
          {/* Server-rendered articles (LearnController), not SPA routes: plain
              links, the same list LearnPage.footer gives the ERB footers. */}
          <Anchor size="sm" c="dimmed" href={LEARN_PATH}>
            Learn
          </Anchor>
          {workspace.learnPages
            .filter((page) => page.footer_label)
            .map((page) => {
              const lang = page.lang === "en" ? undefined : page.lang
              return (
                <Anchor key={page.path} size="sm" c="dimmed" href={page.path} lang={lang} hrefLang={lang}>
                  {page.footer_label}
                </Anchor>
              )
            })}
          <Anchor size="sm" c="dimmed" href={AGENTS_PATH} onClick={(e) => { e.preventDefault(); workspace.goGuides(AGENTS_SLUG) }}>
            Agents
          </Anchor>
          <Anchor size="sm" c="dimmed" href={NWC_PATH}>
            Get NWC code
          </Anchor>
          <Anchor size="sm" c="dimmed" href={SWAP_PROVIDER_PATH}>
            Swap provider
          </Anchor>
          <Anchor size="sm" c="dimmed" href="/contact">
            Contact
          </Anchor>
          <Anchor size="sm" c="dimmed" href="/brand">
            Brand
          </Anchor>
          <Anchor size="sm" c="dimmed" href="/privacy">
            Privacy
          </Anchor>
          <Anchor size="sm" c="dimmed" href={GITHUB_URL} target="_blank" rel="noopener noreferrer">
            GitHub
          </Anchor>
        </Group>
      </Group>
      {/* Vercel's brand guidelines ask every site that shows its marks (the
          Next.js logo, and the Vercel and v0 platform logos) to carry this. */}
      <Text size="xs" c="dimmed" className="or-footer-trademarks">
        Vercel, the Vercel design, Next.js and related marks, designs and logos are trademarks
        or registered trademarks of Vercel, Inc. or its affiliates in the US and other countries.
      </Text>
    </footer>
  )
})
